/**************************************************
 * Nombre:       Seccion_Nosotros
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Nosotros_Portada from "./Componentes/Nosotros_Portada";
import Nosotros_Mision_Vision from "./Componentes/Nosotros_Mision_Vision";
import Nosotros_Certificados from "./Componentes/Nosotros_Certificados";
import Equipo from "./Componentes/Equipo";
import Nosotros_Personal from "./Componentes/Nosotros_Personal";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Nosotros = () => {

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Nosotros_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Nosotros_Mision_Vision/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Nosotros_Certificados/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Equipo/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Nosotros_Personal/>
            </Grid>



        </Grid>
    )

}
export default Seccion_Nosotros

